import axios from 'axios'
import store from '../store'
import { getCookie } from '../util'

const ServiceHost = process.env.VUE_APP_VUE_SERVICE_HOST

const axiosApi = axios.create({
  baseURL: ServiceHost + '/api',
  withCredentials: true,
  headers: {
    'Accept': 'application/json,text/html',
    'Content-Type': 'application/json',
    'Accept-Language': 'zh-TW',
  }
})

axiosApi.interceptors.request.use(function (config) {
  store.commit('addLoadingCount')
  const cookie = getCookie('_admin_jwt')
  if (cookie) {
    config.headers.Authorization = 'BEARER ' + cookie
  }
  return config
}, function (error) {
  let errMsg = null
  if (error.response) {
    errMsg = error.response.data
  } else {
    errMsg = {
      messages: [
        error.message,
      ]
    }
  }

  store.commit('minusLoadingCount')
  store.commit('set', ["errors", errMsg])
  return Promise.reject(error)
})

axiosApi.interceptors.response.use(function (response) {
  store.commit('minusLoadingCount')
  return response
}, function (error) {
  let errMsg = null
  let status = -1

  if (error.response) {
    if (error.response.status) {
      status = error.response.status
    }
    errMsg = error.response.data
  } else {
    errMsg = {
      messages: [
        error.message,
      ]
    }
  }

  if (status === 403) {
    store.commit('set', ['permissionInsufficient', true])
  } else {
    store.commit('set', ["errors", errMsg])
  }

  store.commit('minusLoadingCount')
  return Promise.reject(error)
})

export default axiosApi

export {
  ServiceHost,
}
